import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { queryWorkbench, queryNewDocument, querySystemNotice, toDoList, queryFlowCopyMan, weatherInfo, finishedList as _finishedList } from '@/api/dashboard/homepage.js';
import { queryRepair } from '@/api/repairs/repairsApi.js';
import homeSamll from '@/components/homeSmall';
import homeMain from '@/components/homeMain';
import axios from 'axios';
import { queryReimburse } from '@/api/reimburse/reimburseApi.js';

// axios.defaults.contentType = 'application/json';

export default {
  components: {
    homeSamll: homeSamll,
    homeMain: homeMain
  },
  data: function data() {
    return {
      weatherList: [{
        id: 1,
        name: '晴',
        url: require('@/assets/img/weather/weather01.png')
      }, {
        id: 2,
        name: '少云',
        url: require('@/assets/img/weather/weather02.png')
      }, {
        id: 3,
        name: '晴间多云',
        url: require('@/assets/img/weather/weather03.png')
      }, {
        id: 4,
        name: '多云',
        url: require('@/assets/img/weather/weather04.png')
      }, {
        id: 5,
        name: '阴',
        url: require('@/assets/img/weather/weather05.png')
      }, {
        id: 6,
        name: '有风',
        url: require('@/assets/img/weather/weather06.png')
      }, {
        id: 7,
        name: '平静',
        url: require('@/assets/img/weather/weather07.png')
      }, {
        id: 8,
        name: '微风',
        url: require('@/assets/img/weather/weather08.png')
      }, {
        id: 9,
        name: '和风',
        url: require('@/assets/img/weather/weather09.png')
      }, {
        id: 10,
        name: '清风',
        url: require('@/assets/img/weather/weather10.png')
      }, {
        id: 11,
        name: '强风/劲风',
        url: require('@/assets/img/weather/weather11.png')
      }, {
        id: 12,
        name: '疾风',
        url: require('@/assets/img/weather/weather12.png')
      }, {
        id: 13,
        name: '大风',
        url: require('@/assets/img/weather/weather13.png')
      }, {
        id: 14,
        name: '烈风',
        url: require('@/assets/img/weather/weather14.png')
      }, {
        id: 15,
        name: '风暴',
        url: require('@/assets/img/weather/weather15.png')
      }, {
        id: 16,
        name: '狂爆风',
        url: require('@/assets/img/weather/weather16.png')
      }, {
        id: 17,
        name: '飓风',
        url: require('@/assets/img/weather/weather17.png')
      }, {
        id: 18,
        name: '热带风暴',
        url: require('@/assets/img/weather/weather18.png')
      }, {
        id: 19,
        name: '霾',
        url: require('@/assets/img/weather/weather19.png')
      }, {
        id: 20,
        name: '中度霾',
        url: require('@/assets/img/weather/weather20.png')
      }, {
        id: 21,
        name: '重度霾',
        url: require('@/assets/img/weather/weather21.png')
      }, {
        id: 22,
        name: '严重霾',
        url: require('@/assets/img/weather/weather22.png')
      }, {
        id: 23,
        name: '阵雨',
        url: require('@/assets/img/weather/weather23.png')
      }, {
        id: 24,
        name: '雷阵雨',
        url: require('@/assets/img/weather/weather24.png')
      }, {
        id: 25,
        name: '雷阵雨并伴有冰雹',
        url: require('@/assets/img/weather/weather25.png')
      }, {
        id: 26,
        name: '小雨',
        url: require('@/assets/img/weather/weather26.png')
      }, {
        id: 27,
        name: '中雨',
        url: require('@/assets/img/weather/weather27.png')
      }, {
        id: 28,
        name: '大雨',
        url: require('@/assets/img/weather/weather28.png')
      }, {
        id: 29,
        name: '暴雨',
        url: require('@/assets/img/weather/weather29.png')
      }, {
        id: 30,
        name: '大暴雨',
        url: require('@/assets/img/weather/weather30.png')
      }, {
        id: 31,
        name: '特大暴雨',
        url: require('@/assets/img/weather/weather31.png')
      }, {
        id: 32,
        name: '强阵雨',
        url: require('@/assets/img/weather/weather32.png')
      }, {
        id: 33,
        name: '强雷阵雨',
        url: require('@/assets/img/weather/weather33.png')
      }, {
        id: 34,
        name: '极端降雨',
        url: require('@/assets/img/weather/weather34.png')
      }, {
        id: 35,
        name: '毛毛雨/细雨',
        url: require('@/assets/img/weather/weather35.png')
      }, {
        id: 36,
        name: '雨',
        url: require('@/assets/img/weather/weather36.png')
      }, {
        id: 37,
        name: '小雨-中雨',
        url: require('@/assets/img/weather/weather37.png')
      }, {
        id: 38,
        name: '中雨-大雨',
        url: require('@/assets/img/weather/weather38.png')
      }, {
        id: 39,
        name: '大雨-暴雨',
        url: require('@/assets/img/weather/weather39.png')
      }, {
        id: 40,
        name: '暴雨-大暴雨',
        url: require('@/assets/img/weather/weather40.png')
      }, {
        id: 41,
        name: '大暴雨-特大暴雨',
        url: require('@/assets/img/weather/weather41.png')
      }, {
        id: 42,
        name: '雨雪天气',
        url: require('@/assets/img/weather/weather42.png')
      }, {
        id: 43,
        name: '雨夹雪',
        url: require('@/assets/img/weather/weather43.png')
      }, {
        id: 44,
        name: '阵雨夹雪',
        url: require('@/assets/img/weather/weather44.png')
      }, {
        id: 45,
        name: '冻雨',
        url: require('@/assets/img/weather/weather45.png')
      }, {
        id: 46,
        name: '雪',
        url: require('@/assets/img/weather/weather46.png')
      }, {
        id: 47,
        name: '阵雪',
        url: require('@/assets/img/weather/weather47.png')
      }, {
        id: 48,
        name: '小雪',
        url: require('@/assets/img/weather/weather48.png')
      }, {
        id: 49,
        name: '中雪',
        url: require('@/assets/img/weather/weather49.png')
      }, {
        id: 50,
        name: '大雪',
        url: require('@/assets/img/weather/weather50.png')
      }, {
        id: 51,
        name: '暴雪',
        url: require('@/assets/img/weather/weather51.png')
      }, {
        id: 52,
        name: '小雪-中雪',
        url: require('@/assets/img/weather/weather52.png')
      }, {
        id: 53,
        name: '中雪-大雪',
        url: require('@/assets/img/weather/weather53.png')
      }, {
        id: 54,
        name: '大雪-暴雪',
        url: require('@/assets/img/weather/weather54.png')
      }, {
        id: 55,
        name: '浮尘',
        url: require('@/assets/img/weather/weather55.png')
      }, {
        id: 56,
        name: '扬沙',
        url: require('@/assets/img/weather/weather56.png')
      }, {
        id: 57,
        name: '沙尘暴',
        url: require('@/assets/img/weather/weather57.png')
      }, {
        id: 58,
        name: '强沙尘暴',
        url: require('@/assets/img/weather/weather58.png')
      }, {
        id: 59,
        name: '龙卷风',
        url: require('@/assets/img/weather/weather59.png')
      }, {
        id: 60,
        name: '雾',
        url: require('@/assets/img/weather/weather60.png')
      }, {
        id: 61,
        name: '浓雾',
        url: require('@/assets/img/weather/weather61.png')
      }, {
        id: 62,
        name: '强浓雾',
        url: require('@/assets/img/weather/weather62.png')
      }, {
        id: 63,
        name: '轻雾',
        url: require('@/assets/img/weather/weather63.png')
      }, {
        id: 64,
        name: '大雾',
        url: require('@/assets/img/weather/weather64.png')
      }, {
        id: 65,
        name: '特强浓雾',
        url: require('@/assets/img/weather/weather65.png')
      }, {
        id: 66,
        name: '热',
        url: require('@/assets/img/weather/weather66.png')
      }, {
        id: 67,
        name: '冷',
        url: require('@/assets/img/weather/weather67.png')
      }, {
        id: 68,
        name: '未知',
        url: require('@/assets/img/weather/weather68.png')
      }],
      GdTq: [],
      GdTqCity: '',
      nowTime: '',
      nowWeek: '',
      nowDate: '',
      showLoading: true,
      showLoading1: true,
      showLoading2: true,
      showLoading3: true,
      mainList: [{
        typeIndex: 0,
        list: [],
        list1: []
      }],
      mainList1: [{
        typeIndex: 1,
        yiyueList: [],
        daiyueList: []
      }],
      allList: [{
        typeIndex: 0,
        newList: [],
        afficheList: [],
        systemList: []
      }],
      allList1: [{
        typeIndex: 1,
        applyList: [],
        serviceList: []
      }],
      imgUrl: '',
      defaultImgUrl: require('@/assets/img/weather/weather01.png'),
      defaultNumber: 30
    };
  },
  created: function created() {
    this.getTime();
    this.workbench();
    this.newDocument();
    this.systemNotice();
    this.getToDoList();
    this.getFlowCopyMan();
    this.getGD();
    this.getQueryRepair();
    this.getQueryReimburse();
    this.finishedList();
  },
  mounted: function mounted() {
    var _this = this;
    this.timer = setInterval(function () {
      _this.getTime();
    }, 60000);
  },
  methods: {
    /**
     * 获取报销数据
     */
    getQueryReimburse: function getQueryReimburse() {
      var _this2 = this;
      this.showLoading3 = true;
      queryReimburse(1, 10, {}).then(function (res) {
        if (res.data.code == 200) {
          _this2.allList1.applyList = res.data.data;
          _this2.$set(_this2.allList1, 'applyList', res.data.data);
          _this2.$refs.repairs.baoxiao(res.data.data);
          _this2.showLoading3 = false;
        }
      }).finally(function () {
        _this2.showLoading3 = false;
      });
    },
    /**
     * 获取报修数据
     */
    getQueryRepair: function getQueryRepair() {
      var _this3 = this;
      this.showLoading3 = true;
      queryRepair(1, 10, {}).then(function (res) {
        if (res.data.code == 200) {
          _this3.allList1.serviceList = res.data.data;
          _this3.$set(_this3.allList1, 'serviceList', res.data.data);
          _this3.$refs.repairs.baoxiu(res.data.data);
          _this3.showLoading3 = false;
        }
      }).finally(function () {
        _this3.showLoading3 = false;
      });
    },
    /**
     * 快捷按钮跳转
     */
    viewTo: function viewTo(path) {
      if (path == 'processApplication') {
        this.$router.push({
          path: '/formReview/reviewCenter/processApplication'
        });
      } else if (path == 'myApplication') {
        this.$router.push({
          path: '/formReview/reviewCenter/myApplication'
        });
      } else if (path == 'register') {
        this.$router.push({
          path: '/reimburseRepairs/repairs/register'
        });
      } else if (path == 'list') {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/list'
        });
      }
    },
    /**
     * 获取天气信息
     */
    getGD: function getGD() {
      var _this4 = this;
      weatherInfo().then(function (res) {
        _this4.GdTq = res.data.lives[0];
        for (var i = 0; i < _this4.weatherList.length; i++) {
          if (_this4.weatherList[i].name === _this4.GdTq.weather) {
            _this4.imgUrl = _this4.weatherList[i].url;
            break;
          }
        }
      });
    },
    //获取当前时间
    getTime: function getTime() {
      //获取当前时间
      var myDate = new Date();
      var wk = myDate.getDay();
      var yy = String(myDate.getFullYear());
      var mm = myDate.getMonth() + 1;
      var dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate());
      var hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours());
      var min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes());
      var sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds());
      var weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      var week = weeks[wk];
      this.nowDate = mm + '月' + dd + '日';
      this.nowTime = hou + ':' + min;
      this.nowWeek = week;
    },
    /**
     * 获取最新公文
     */
    newDocument: function newDocument() {
      var _this5 = this;
      this.showLoading2 = true;
      queryNewDocument(1, 5).then(function (res) {
        // this.allList[0].newList = res.data.data.rows;
        _this5.$set(_this5.allList[0], 'newList', res.data.data.rows);
        _this5.$refs.smallRef.refresh1(res.data.data.rows);
        _this5.showLoading2 = false;
      }).finally(function () {
        _this5.showLoading2 = false;
      });
    },
    /**
     * 获取通知公告
     */
    workbench: function workbench() {
      var _this6 = this;
      this.showLoading2 = true;
      queryWorkbench(1, 5).then(function (res) {
        // this.allList[0].afficheList = res.data.data;
        _this6.$set(_this6.allList[0], 'afficheList', res.data.data);
        _this6.$refs.smallRef.refresh(res.data.data);
        _this6.showLoading2 = false;
      }).finally(function () {
        _this6.showLoading2 = false;
      });
    },
    /**
     * 获取系统通知
     */
    systemNotice: function systemNotice() {
      var _this7 = this;
      this.showLoading2 = true;
      querySystemNotice(1, 5).then(function (res) {
        _this7.$set(_this7.allList[0], 'systemList', res.data.data.rows);
        _this7.$refs.smallRef.refresh2(res.data.data.rows);
        _this7.showLoading2 = false;
      }).finally(function () {
        _this7.showLoading2 = false;
      });
    },
    /**
     * 待办
     */
    getToDoList: function getToDoList() {
      var _this8 = this;
      this.showLoading = true;
      toDoList(1, 20).then(function (res) {
        _this8.$set(_this8.mainList[0], 'list', res.data.data.rows);
        _this8.$refs.refresh.refresh(res.data.data.rows);
      }).finally(function () {
        _this8.showLoading = false;
      });
    },
    /**
     * 已办
     */
    finishedList: function finishedList() {
      var _this9 = this;
      this.showLoading = true;
      _finishedList(1, 20).then(function (res) {
        _this9.$set(_this9.mainList[0], 'list1', res.data.data.rows);
        _this9.$refs.refresh.refresh2(res.data.data.rows);
      }).finally(function () {
        _this9.showLoading = false;
      });
    },
    /**
     * 待阅
     */
    getFlowCopyMan: function getFlowCopyMan() {
      var _this0 = this;
      this.mainList1[0].yiyueList = [];
      this.mainList1[0].daiyueList = [];
      this.showLoading1 = true;
      queryFlowCopyMan(1, 20).then(function (res) {
        res.data.data.rows.forEach(function (item) {});
        _this0.$refs.refresh1.refresh1(res.data.data.rows);
      }).finally(function () {
        _this0.showLoading1 = false;
      });
    }
  }
};